import React from 'react';
import { CheckCircle, Clock, AlertCircle, MessageCircle } from 'lucide-react';

const statusIcons = {
  active: <CheckCircle size={16} className="text-green-400" />,
  waiting: <Clock size={16} className="text-yellow-400" />,
  error: <AlertCircle size={16} className="text-red-400" />,
};

export default function AgentSidebar({ agents, selectedAgent, onSelectAgent }) {
  return (
    <aside className="w-64 bg-[#0a0a0a] border-r border-white/5 flex flex-col h-full overflow-hidden">
      {/* Header */}
      <div className="px-6 py-4 border-b border-white/5">
        <h2 className="text-sm font-semibold text-white flex items-center gap-2">
          <span className="text-lg">🤖</span>
          Agents
        </h2>
      </div>

      {/* Agent List */}
      <div className="flex-1 overflow-y-auto">
        {agents.map((agent) => (
          <button
            key={agent.id}
            onClick={() => onSelectAgent(agent.id)}
            className={`w-full px-4 py-3 border-b border-white/5 transition-colors text-left ${
              selectedAgent === agent.id
                ? 'bg-white/10 border-l-2 border-l-[#10b981]'
                : 'hover:bg-white/5'
            }`}
          >
            <div className="flex items-start gap-3">
              {/* Status Icon */}
              <div className="mt-0.5 flex-shrink-0">{statusIcons[agent.status]}</div>

              {/* Agent Info */}
              <div className="min-w-0 flex-1">
                <p className="font-medium text-sm text-white">{agent.name}</p>
                <p className="text-xs text-white/50 truncate mt-1">{agent.lastMessage}</p>
                <p className="text-xs text-white/40 mt-0.5">{agent.lastMessageTime}</p>

                {/* WhatsApp indicator */}
                {agent.whatsappConnected && (
                  <div className="flex items-center gap-1 mt-1.5 text-[11px] text-green-400">
                    <MessageCircle size={12} />
                    <span>WhatsApp connected</span>
                  </div>
                )}
              </div>

              {/* Unread Badge */}
              {agent.unreadCount > 0 && (
                <div className="flex-shrink-0 bg-[#10b981] text-black text-[10px] font-bold w-5 h-5 rounded-full grid place-items-center">
                  {agent.unreadCount > 9 ? '9+' : agent.unreadCount}
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      {/* Footer Info */}
      <div className="px-4 py-3 border-t border-white/5 text-[11px] text-white/50">
        <p className="text-center">All agents synced</p>
      </div>
    </aside>
  );
}
